export default __webpack_public_path__ + "static/media/land_loard.1e5cbbb9.png";